/* eslint-disable max-len */
import React, { useContext } from 'react';
import { Menu, MenuItem } from '@mui/material';
import { BsFolder } from 'react-icons/bs';
import { LanguageContext } from '../../../libs/Context';
import PropTypes from 'prop-types';

const MediaMenuItem = (props) =>
{
	const ITEM_HEIGHT = 100;
	const { anchorEl, handleClose, breadCrumbs, handleMain, handleNavigate, type, open } = props;
	const { language } = useContext(LanguageContext);

	const handleKeeUp = (e, item, index) =>
	{
		if (e.key === 'Enter')
		{
			if (breadCrumbs.length !== index + 1)
			{
				handleNavigate(type === 'common' ? item?.id : item, (type === 'common' && item));
			}
		}
	};

	return (
		<Menu
			id='long-menu'
			MenuListProps={{
				'aria-labelledby' : 'long-button'
			}}
			anchorEl={anchorEl}
			open={open}
			onClose={handleClose}
			PaperProps={{
				style : {
					maxHeight : ITEM_HEIGHT * 4.5,
					maxWidth  : '40ch'
				}
			}}
		>
			<MenuItem>
				<button className='flexRow alignCntr' tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && handleMain(); }} onClick={handleMain}>
					<div className='flexAutoRow ' style={{ marginLeft: '0px' }}>
						<BsFolder fontSize={'var(--pixel24)'} className='primaryTxt mrgnRXS' />
					</div>
					<div className='flexMinWidthRow'>
						<span className='subHeadingSM capitalTxt'>{language.main}</span>
					</div>
				</button>
			</MenuItem>
			{breadCrumbs?.map((item, index) => (
				<MenuItem key={item?.id}>
					<button
						tabIndex={0}
						className='flexRow alignCntr'
						onClick={
							breadCrumbs.length !== index + 1
								? () => handleNavigate(type === 'common' ? item?.id : item, (type === 'common' && item))
								: () => {}
						}
						onKeyUp={(e) => handleKeeUp(e, item, index)}
					>
						<div
							className='flexAutoRow '
							style={{ marginLeft: `${(index + 1) * 8}px` }}
						>
							<BsFolder fontSize={'var(--pixel24)'} className='primaryTxt mrgnRXS' />
						</div>
						<div className='flexMinWidthRow'>
							<span className='subHeadingSM ellipsisTxt capitalTxt'>
								{item?.name}
							</span>
						</div>
					</button>
				</MenuItem>
			))}
		</Menu>
	);
};

MediaMenuItem.propTypes = {
	anchorEl       : PropTypes.any,
	handleClose    : PropTypes.func,
	breadCrumbs    : PropTypes.array,
	handleMain     : PropTypes.func,
	handleNavigate : PropTypes.func,
	type           : PropTypes.string,
	open           : PropTypes.bool
};

export default MediaMenuItem;
